import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import BulkUploadQuestions from '../../../components/QuestionBank/BulkUploadQuestions';
import UploadHistorySection from '../../../components/QuestionBank/UploadHistorySection';

// Error boundary to prevent crashes from propagating
class BulkUploadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('BulkUploadPage error boundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card className="shadow mt-4">
          <CardBody className="text-center py-5">
            <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
            <h3>Something went wrong</h3>
            <p className="text-muted">
              An error occurred while loading this section. Please try refreshing the page.
            </p>
            <Button
              color="primary"
              onClick={() => this.setState({ hasError: false, error: null })}
            >
              <i className="fas fa-redo mr-2"></i>
              Try Again
            </Button>
          </CardBody>
        </Card>
      );
    }
    return this.props.children;
  }
}

const BulkUploadPage = ({ userDetails }) => {
  const userEmail = userDetails?.email || '';

  return (
    <>
      {/* Header */}
      <div className="header bg-gradient-success pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <h1 className="text-white mb-0">Bulk Upload & Edit</h1>
            <p className="text-white mt-0 mb-0">Upload new questions or export and bulk edit existing ones</p>
          </div>
        </Container>
      </div>

      {/* Page content */}
      <Container className="mt--7" fluid>
        <BulkUploadErrorBoundary>
          <Row>
            <Col lg="12">
              <BulkUploadQuestions userEmail={userEmail} />
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <UploadHistorySection folder="bulk_upload" title="Bulk Upload History" />
              <UploadHistorySection folder="bulk_edit" title="Bulk Edit History" />
            </Col>
          </Row>
        </BulkUploadErrorBoundary>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  userDetails: state.loginAuth.userDetails
});

export default connect(mapStateToProps)(BulkUploadPage);
